const { getElement } = window.BAO.Utils
const { fetchSingle, convertToDOM } = window.BAO.sectionRenderer

class ProductColours extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['title']
  }

  currentTitle = this.els.title.element.dataset.defaultColour

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.colour?.elements) return

    this.listeners.add(this, 'click', this.handleClick.bind(this))

    this.listeners.add(
      document,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.onVariantChanged.bind(this),
    )

    if (!window.BAO.MediaBreakpoints.isSm) return

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.colour.elements.forEach(colour => {
      this.listeners.add(colour, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(colour, 'mouseleave', this.handleMouseLeave)
    })
  }

  onVariantChanged (e) {
    const variantId = e?.detail?.variant?.data?.id
    const productId = getElement('[data-product-id]').dataset.productId

    this.updateWishlistButtons(productId, variantId)
  }

  async handleClick (event) {
    if (!event.target.closest(this.els.colour.selector)) return
    event.preventDefault()

    const nextUrl = event.target.getAttribute('href')

    const templateId = document.getElementById('template-product').dataset.id

    const responseHTML = await fetchSingle(templateId, nextUrl)
    const responseDOM = convertToDOM(responseHTML)

    const currentMediaColumnEl = getElement('[data-product-column-media]', {
      context: document,
    })
    const currentDetailColumnEl = getElement('[data-product-detail]', {
      context: document,
    })
    const currentFormEl = getElement('[data-product-form]', {
      context: document,
    })
    const currentSizeGuideEl = getElement('[data-size-guide]', {
      context: document,
    })
    const currentTabsEl = getElement('[data-tabs]', { context: document })
    const currentAdditionalMediaEl = getElement('[data-product-additional]', {
      context: document,
    })
    const currentMobileBuyEl = getElement('[data-product-mobile-buy]', {
      context: document,
    })
    const currentProductIdEl = getElement('[data-product-id]', {
      context: document,
    })
    const currentVariantIdEl = getElement('[data-first-available-variant-id]', {
      context: document,
    })

    const newMediaColumnEl = getElement('[data-product-column-media]', {
      context: responseDOM,
    })
    const newDetailColumnEl = getElement('[data-product-detail]', {
      context: responseDOM,
    })
    const newFormEl = getElement('[data-product-form]', {
      context: responseDOM,
    })
    const newSizeGuideEl = getElement('[data-size-guide]', {
      context: responseDOM,
    })
    const newTabsEl = getElement('[data-tabs]', { context: responseDOM })
    const newAdditionalMediaEl = getElement('[data-product-additional]', {
      context: responseDOM,
    })
    const newMobileBuyEl = getElement('[data-product-mobile-buy]', {
      context: responseDOM,
    })
    const newProductIdEl = getElement('[data-product-id]', {
      context: responseDOM,
    })
    const newVariantIdEl = getElement('[data-first-available-variant-id]', {
      context: responseDOM,
    })

    const pageTitleEl = getElement('[data-page-title]', {
      context: responseDOM,
    })
    const nextTitle = pageTitleEl?.dataset?.pageTitle || ''

    if (currentMediaColumnEl && newMediaColumnEl) {
      currentMediaColumnEl.innerHTML = newMediaColumnEl.innerHTML
    }

    if (currentDetailColumnEl && newDetailColumnEl) {
      currentDetailColumnEl.innerHTML = newDetailColumnEl.innerHTML
    }

    if (currentFormEl && newFormEl) {
      currentFormEl.innerHTML = newFormEl.innerHTML
    }

    if (currentSizeGuideEl && newSizeGuideEl) {
      currentSizeGuideEl.innerHTML = newSizeGuideEl.innerHTML
    }

    if (currentTabsEl && newTabsEl) {
      currentTabsEl.innerHTML = newTabsEl.innerHTML
    }

    if (currentAdditionalMediaEl && newAdditionalMediaEl) {
      currentAdditionalMediaEl.innerHTML = newAdditionalMediaEl.innerHTML
    }

    if (currentMobileBuyEl && newMobileBuyEl) {
      currentMobileBuyEl.innerHTML = newMobileBuyEl.innerHTML
    }

    const drawerResponseHTML = await fetchSingle(
      'product-options-drawer',
      nextUrl,
    )
    const drawerResponseDOM = convertToDOM(drawerResponseHTML)

    const currentDrawerProductOptionsEl = getElement(
      '[data-drawer-product-options]',
      {
        context: document,
      },
    )
    const newDrawerProductOptionsEl = getElement(
      '[data-drawer-product-options]',
      {
        context: drawerResponseDOM,
      },
    )
    if (currentDrawerProductOptionsEl && newDrawerProductOptionsEl) {
      currentDrawerProductOptionsEl.innerHTML =
        newDrawerProductOptionsEl.innerHTML
    }

    const currentDrawerBisEl = getElement('[data-drawer-bis]', {
      context: document,
    })
    const newDrawerBisEl = getElement('[data-drawer-bis]', {
      context: drawerResponseDOM,
    })
    if (currentDrawerBisEl && newDrawerBisEl) {
      currentDrawerBisEl.innerHTML = newDrawerBisEl.innerHTML
    }

    const nextProductId = newProductIdEl?.dataset?.productId || ''
    if (currentProductIdEl && newProductIdEl) {
      currentProductIdEl.dataset.productId = nextProductId
    }

    const nextVariantId = newVariantIdEl?.dataset?.firstAvailableVariantId || ''
    if (currentVariantIdEl && nextVariantId) {
      currentVariantIdEl.dataset.firstAvailableVariantId = nextVariantId
    }

    if (window.history.replaceState) {
      window.history.replaceState({}, nextTitle, nextUrl)
    }

    document.title = nextTitle

    this.updateWishlistButtons(
      currentProductIdEl.dataset.productId,
      currentVariantIdEl.dataset.firstAvailableVariantId,
    )
  }

  updateWishlistButtons (productId, variantId) {
    /* Annoyingly, the wishlist buttons don't work after section render, so have to update them manually */
    let wishlistAdded = false

    if (
      typeof Storage !== 'undefined' &&
      localStorage.getItem('iWishlistmain') !== null
    ) {
      const wishlistLocalStorage = JSON.parse(
        localStorage.getItem('iWishlistmain'),
      )

      for (const key in wishlistLocalStorage) {
        if (key === productId) {
          if (wishlistLocalStorage[key].includes(variantId.toString())) {
            wishlistAdded = true
          }
        }
      }
    }

    const wishlistButtons = document.querySelectorAll('.wsh-Wishlist_Button')

    wishlistButtons.forEach(wishlistButton => {
      wishlistButton.dataset.variant = variantId
      wishlistButton.dataset.product = productId

      wishlistButton.classList.toggle('iwishAdded', wishlistAdded)

      if (wishlistAdded) {
        wishlistButton.innerHTML =
          '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M7.24275 9.57125 3 12.1169V2.5h9v9.6169L7.75725 9.57125 7.5 9.4169l-.25725.15435Z" fill="currentColor" stroke="currentColor"></path></svg><span>Added</span>'
      } else {
        wishlistButton.innerHTML =
          '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path fill-rule="evenodd" clip-rule="evenodd" d="m7.5 10 5 3V2h-10v11l5-3Zm-4 1.2338 4-2.39999 4 2.39999V3h-8v8.2338Z" fill="currentColor"></path></svg><span>Add to wishlist</span>'
      }
    })
  }

  handleMouseEnter (e) {
    this.els.title.element.textContent = e.currentTarget.dataset.title
  }

  handleMouseLeave (e) {
    if (this.currentTitle !== e.currentTarget.dataset.title) {
      this.els.title.element.textContent = this.currentTitle
    }
  }
}

if (!customElements.get('product-colours')) {
  customElements.define('product-colours', ProductColours)
}
